export default __webpack_public_path__ + "static/media/it-support-maintenance.accac6f6.png";